// extracted by mini-css-extract-plugin
module.exports = {"card":"machineryCard_card__hr_Xk"};